<template>
	<div class="container-fluid bg-white">
		<toolbar>
			<h2><i class="fa fa-handshake"></i> Collective Agreements</h2>

			<div class="controls">

			</div>
		</toolbar>

		<collective-agreements-component></collective-agreements-component>
	</div>
</template>

<script>
import NavTabs from "../layout_fragments/NavTabs"
import Toolbar from "../layout_fragments/Toolbar"

import CollectiveAgreementsComponent from "../components/super_components/CollectiveAgreementsComponent"

export default {

	name: 'CollectiveAgreements',
	components: {
		Toolbar,
		NavTabs,
		CollectiveAgreementsComponent
	}

}
</script>